import React from 'react';
import { Text, Tooltip, Icon } from '@perch-labs/shrike';
import { Container, LabelAndTooltip } from 'styles';
import { ModuleContainer } from '../impact-modules.style';
import { DesktopOnlySVG, StyledBadge } from './styled-module.style';

interface TooltipProps {
  tooltipId: string;
  content: string;
  label: string;
}

interface Props {
  title: string;
  tooltipProps: TooltipProps;
  boldCopy: string | null;
  svgSrc: string;
  badgeCopy: string;
  showBadge: boolean;
}

export const StyledModule = ({
  title,
  tooltipProps,
  boldCopy,
  svgSrc,
  badgeCopy,
  showBadge,
}: Props) => {
  const { tooltipId, content, label } = tooltipProps;
  const text = (
    <Text
      className="notranslate"
      textStyle="heading800"
      margin={{ top: '8px', right: '8px' }}
    >
      {boldCopy}
    </Text>
  );

  return (
    <ModuleContainer>
      <Container
        small={{
          direction: 'column',
          flex: true,
          height: '143px',
          justifyContent: 'space-between',
        }}
      >
        <Container flex justifyContent="space-between" small={{ width: '80%' }}>
          <LabelAndTooltip color="secondary">
            {title}
            <Tooltip
              content={content}
              tooltipId={tooltipId}
              label={label}
              maxWidth={250}
            >
              <Icon
                icon="InfoCircleInverted"
                color="secondary"
                aria-hidden={true}
              />
            </Tooltip>
          </LabelAndTooltip>
          <DesktopOnlySVG src={svgSrc} aria-hidden={true} />
        </Container>
        <Container
          flex
          wrap="wrap"
          alignItems="center"
          small={{ direction: 'column', alignItems: 'flex-start' }}
        >
          {text}
          {showBadge && (
            <StyledBadge
              className="notranslate"
              backgroundColor="accent3"
              margin={{ top: '8px' }}
            >
              {badgeCopy}
            </StyledBadge>
          )}
        </Container>
      </Container>
    </ModuleContainer>
  );
};
